// extracted by mini-css-extract-plugin
export default {"form_control":"Select_form_control__7zgkc","personalizar-select":"Select_personalizar-select__AITP6","personalizar-option":"Select_personalizar-option__7PiNh"};